export default __webpack_public_path__ + "static/media/icon-save.4610711d.svg";